import { render, staticRenderFns } from "./SeminarLodging.vue?vue&type=template&id=5c505886&scoped=true&"
import script from "./SeminarLodging.vue?vue&type=script&lang=js&"
export * from "./SeminarLodging.vue?vue&type=script&lang=js&"
import style0 from "./SeminarLodging.vue?vue&type=style&index=0&id=5c505886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c505886",
  null
  
)

export default component.exports